module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Windguru.js"));
	}, "Windguru");
}